import { $t } from '../../composables/i18n'
import CodebookValueNotFoundError from '../CodebookValueNotFoundError'

export enum CalendarUnitId {
  MONTH_AND_DAY = 1,
  HOUR_AND_MINUTE = 2,
  DAY_AND_HOUR = 3,
}

export class CalendarUnit {
  static readonly MONTH_AND_DAY = new CalendarUnit(CalendarUnitId.MONTH_AND_DAY, false, () =>
    $t('Days'),
  )
  static readonly HOUR_AND_MINUTE = new CalendarUnit(CalendarUnitId.HOUR_AND_MINUTE, true, () =>
    $t('Minutes'),
  )
  static readonly DAY_AND_HOUR = new CalendarUnit(CalendarUnitId.DAY_AND_HOUR, true, () =>
    $t('Hours'),
  )

  private constructor(
    public readonly id: CalendarUnitId,
    public readonly isHourly: boolean,
    public readonly name: () => string,
  ) {}

  static getById = (id: CalendarUnitId): CalendarUnit => {
    const value = CalendarUnit.all().find((item) => item.id === id)

    if (value === undefined) {
      throw new CodebookValueNotFoundError(CalendarUnit.name, id)
    }

    return value
  }

  static all = (): CalendarUnit[] => {
    return [CalendarUnit.MONTH_AND_DAY, CalendarUnit.HOUR_AND_MINUTE, CalendarUnit.DAY_AND_HOUR]
  }

  static allNonHourly = (): CalendarUnit[] => {
    return CalendarUnit.all().filter((cu) => !cu.isHourly)
  }
}
